<template>
	<div class="order-creator-page">
		<nio-header-nav
			position="fixed"
			:is-white="true"
			@back="handleBack"
			:height.sync="headerHeight"
		/>

		<div
			class="main-content"
			:style="{
				paddingTop: headerHeight + 15 + 'px',
				paddingBottom: insetBottom + 'px'
			}"
		>
			<div class="main-content-title">
				预定爱车
			</div>

			<div class="section-car-card">
				<order-car-item v-if="!!car" :car="carItemInfo" />
			</div>
			<div class="main-content-title__sub">预定方式</div>
			<div class="main-content-price-block">
				<div class="main-content-price-block__label">定金</div>
				<div class="main-content-price-block__value">
					¥{{ toMoneyFormat(Number(depositAmount)) }}
				</div>
			</div>
			<!-- 表单信息 -->
			<owner-info-form :isCreated="true" v-model="formData" ref="ownerInfoForm" />
			<div class="price-detail">
				<div class="main-content-title__sub">价格明细</div>
				<div class="price-detail-block">
					<div class="price-detail-block-label">
						{{ car && car.basic ? car.basic.commodity_name : '' }}
					</div>
					<div class="price-detail-block-value">
						¥ {{ car && car.sell_programme ? toMoneyFormat(car.sell_programme.sell_price) : '' }}
					</div>
				</div>
				<!-- <div class="price-detail-block">
					<div class="price-detail-block-label">国家补贴</div>
					<div class="price-detail-block-value">-¥ 20000</div>
				</div> -->
				<div class="price-detail-block price-detail-block-additional">
					<div class="price-detail-block-label">购车总价</div>
					<div class="price-detail-block-value ">
						<div>
							¥ {{ car && car.sell_programme ? toMoneyFormat(car.sell_programme.sell_price) : '' }}
						</div>
					</div>
				</div>
				<div class="price-detail-money">
					含定金 ¥{{ toMoneyFormat(Number(depositAmount)) }}，尾款 ¥{{
						car && car.sell_programme
							? toMoneyFormat(car.sell_programme.sell_price - Number(depositAmount))
							: ''
					}}
				</div>
				<div class="price-detail-tips">
					*供参考，具体补贴金额由定金支付时间和上牌时补贴政策等决定。
				</div>
				<div class="price-detail-tips">*购车总价请参考订单页面价格明细</div>
			</div>
			<div class="agreement">
				<nio-check v-model="formData.checked"></nio-check>
				我已阅读并同意
				<nio-button
					text="《汽车购买协议》"
					:round="false"
					type="btn_text"
					:disabled="false"
					@click="gotoPreview"
				/>
			</div>
			<div class="submit-btn">
				<nio-button
					round
					:disabled="btnDisabled"
					:text="`支付定金¥${toMoneyFormat(Number(depositAmount))}`"
					@click="submit"
				></nio-button>
			</div>
		</div>
	</div>
</template>

<script>
import nativeHybrid from '@/util/nativeHybrid'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import {
	queryVehicleDetail,
	createOrder,
	viewPurchaseAgreement,
	getDepositAmount,
	getOrderTradeNo,
	getLocationWithCity,
	queryTradeStatus,
	getOrderDetail,
	checkPayStatus
} from '@/model'
import { carDetailToCarItem } from '@/util/data-transfer'
import OrderCarItem from '@/components/OrderCarItem'
import { toMoneyFormat } from './conf'
import OwnerInfoForm from '@/components/OwnerInfoForm.vue'
import { supreme } from '@/supreme-core'
import link from '@/util/link'
import util from '@/util/util'
import { cardType } from '@/views1/CarOwnerInfoPage/conf'
import qs from 'qs'
export default {
	name: 'orderCreator',
	components: {
		OrderCarItem,
		OwnerInfoForm
	},
	data() {
		return {
			headerHeight: 0,
			insetBottom: getSafeInsetBottom(),
			car: null,
			formData: {
				//车辆所有人类型
				ownerType: 1,
				//车辆所有人姓名
				ownerName: '',
				//车辆所有人手机号
				ownerPhone: '',
				ownerIdCode: '',
				cardTypeInfo: null,
				registerCityInfo: null,
				checked: false
			},
			previewUrl: '',
			depositAmount: '',
			btnDisabled: true,
			depositTradeNo: '',
			merchantNo: '',
			//currentAreaCode: '',
			orderNo: '',
			isPaying: false
		}
	},
	computed: {
		carItemInfo() {
			if (!this.car) {
				return null
			}
			return carDetailToCarItem(this.car)
		}
	},
	created() {
		if (util.isInWebview()) {
			nativeHybrid.registerKeyboardStateChange(function(l) {
				const isAndroid = navigator.userAgent.match('Android')
				if (isAndroid) {
					document.body.style.paddingBottom = l / window.devicePixelRatio + 'px'
				}
			})
		}
		this.$nextTick(() => {
			this.formData.cardTypeInfo = {
				value: 1,
				name: cardType[1]
			}
		})
		this.fetchDetail()
		const old_order_no = supreme.getQueryString('old_order_no')
		if (old_order_no) {
			this.fetchOrderDetail(old_order_no)
		}
	},

	methods: {
		toMoneyFormat,
		onAppear() {
			let checkPayResult = false

			// 客户端支付台返回
			if (this.isPaying) {
				checkPayResult = true
			}

			// 微信小程序支付跳转
			if (nativeHybrid.isWeapp() && location.href.indexOf('pay_finish') > 0) {
				checkPayResult = true
			}

			if (!checkPayResult) {
				return
			}

			this.isPaying = false
			// todo: 请求后端是否支付成功

			queryTradeStatus.get({ order_no: this.orderNo, trade_no: this.depositTradeNo }).then(res => {
				const { data } = res
				if (!data || data.result_code !== 'success') {
					let error = {}
					error.message = data.debug_msg || data.display_msg || '网络错误'
					throw error
				}
				const { code, trade_no_type } = data.data

				this.isPaying = false

				if (trade_no_type === 1 && code === 2) {
					link.goToRoute(
						'/pay-result',
						{
							success: 'true',
							order_no: this.orderNo
						},
						true
					)
				} else {
					link.goToRoute(
						'/order-detail',
						{
							order_no: this.orderNo
						},
						true
					)
				}

				// setTimeout(() => {
				// 	nativeHybrid.closeSyn()
				// }, 500)
			})
		},
		handleBack() {
			nativeHybrid.closeSyn()
		},

		submit() {
			this.$refs.ownerInfoForm.$refs.Form.validate()
				.then(async () => {
					const {
						ownerType,
						ownerName,
						ownerPhone,
						ownerIdCode,
						registerCityInfo,
						cardTypeInfo,
						...rest
					} = this.formData
					//810891669292459065
					let params = {}
					if (ownerType === 1) {
						params = {
							commodity_code: this.car.basic.commodity_code,
							owner_name: ownerName,
							owner_phone: ownerPhone,
							owner_id_type: cardTypeInfo.value,
							owner_id_code: ownerIdCode,
							owner_type: ownerType,
							registration_city: registerCityInfo.city.area_code
						}
					} else {
						params = {
							commodity_code: this.car.basic.commodity_code,
							owner_name: ownerName,
							owner_id_type: 7,
							owner_id_code: ownerIdCode,
							owner_type: ownerType,
							registration_city: registerCityInfo.city.area_code
						}
					}
					this.$showLoading({
						type: 'loading',
						text: '加载中'
					})
					try {
						// 校验订金是否被支付
						const { data } = await checkPayStatus.get({}, `/${this.car.basic.commodity_code}`)
						if (!data || data.result_code !== 'success') {
							let error = {}
							error.message = data.debug_msg || data.display_msg || '网络错误'
							throw error
						}

						if (data.data.is_payed === true) {
							this.$toast('该车辆已被抢定了，可以看看其他车辆哦')
							this.$hideLoading()
							return
						}

						createOrder
							.post(params)
							.then(res => {
								console.log(res)
								const { data } = res
								if (!data || data.result_code !== 'success') {
									let error = {}
									error.message = data.debug_msg || data.display_msg || '网络错误'
									throw error
								}
								this.orderNo = data.data.order_no
								this.getOrderTradeNo(data.data.order_no)
								this.$hideLoading()
								// this.$toast('成功')
							})
							.catch(error => {
								console.log(error)
								this.$hideLoading()
								this.$toast(error.message)
							})
					} catch (error) {
						console.log(`error ===> `, error)
						this.$hideLoading()
						this.$toast(error.message)
					}
				})
				.catch(err => {
					console.log(err)
				})
		},

		async fetchDetail() {
			try {
				const { data } = await queryVehicleDetail.get({}, '/' + supreme.getQueryString('sku_code'))

				if (!data || data.result_code !== 'success') {
					throw new Error()
				}

				this.car = data.data
				this.getDepositAmount()
			} catch (e) {
				if (util.isInWebview()) {
					this.$router.push({ path: '/error', query: { message: '网络请求失败' } })
				}
			}
		},

		// getPurchaseAgreement() {
		// 	viewPurchaseAgreement
		// 		.get({})
		// 		.then(res => {
		// 			const { data } = res
		// 			if (!data || data.result_code !== 'success') {
		// 				let error = {}
		// 				error.message = data.debug_msg || data.display_msg || '网络错误'
		// 				throw error
		// 			}
		// 			this.previewUrl = data.data.box_url
		// 		})
		// 		.catch(err => {
		// 			console.log(err)
		// 		})
		// },
		getDepositAmount() {
			getDepositAmount.get({ order_type: this.car.basic.business_type }).then(res => {
				const { data } = res
				if (!data || data.result_code !== 'success') {
					let error = {}
					error.message = data.debug_msg || data.display_msg || '网络错误'
					throw error
				}
				this.depositAmount = data.data.deposit_amount
			})
		},
		getOrderTradeNo(order_no) {
			getOrderTradeNo
				.get({ order_no, trade_type: 1 })
				.then(res => {
					const { data } = res
					if (!data || data.result_code !== 'success') {
						let error = {}
						error.message = data.debug_msg || data.display_msg || '网络错误'
						throw error
					}
					this.depositTradeNo = data.data.pay_order_no
					this.merchantNo = data.data.merchant_no
					this.isPaying = true
					this.payDeposit()
				})
				.catch(err => {
					console.log(err)
				})
		},
		gotoPreview() {
			link.goToRoute('/carPurchaseAgreement')
		},
		payDeposit() {
			if (nativeHybrid.isWeapp()) {
				const subpath = '/orderCreator?sku_code' + supreme.getQueryString('sku_code')
				const params = {
					amount: Number(this.depositAmount),
					payOrderNo: this.depositTradeNo,
					merchantNo: this.merchantNo,
					body: encodeURIComponent('官方二手车'),
					successCallbackUrl: `/modules/second-hand/pages/SecondHand?page=${encodeURIComponent(
						subpath + '&pay_finish=true'
					)}`,
					failCallbackUrl: `/modules/second-hand/pages/SecondHand?page=${encodeURIComponent(
						subpath + '&pay_finish=true'
					)}`,
					originUrl: `/modules/second-hand/pages/SecondHand?page=${encodeURIComponent(subpath)}`
				}

				let url = '/pages/pay2/index?' + qs.stringify(params)
				window.wx.miniProgram.redirectTo({
					url: url
				})
			} else {
				const url = `nio://pay/paylist?merchant_no=${this.merchantNo}&pay_order_no=${this.depositTradeNo}`
				console.log(url)
				nativeHybrid.openURL(url)
			}
		},
		async fetchOrderDetail(orderNo) {
			try {
				const { data } = await getOrderDetail.get({}, `/${orderNo}/detail`)

				if (!data || data.result_code !== 'success') {
					let error = {}
					error.message = data.debug_msg || data.display_msg || '网络错误'
					throw error
				}
				const ownerInfo = data.data.owner

				const {
					owner_id_code,
					owner_id_type,
					owner_name,
					owner_phone,
					owner_type,
					registration_city_code,
					registration_city_name
				} = ownerInfo

				this.formData.ownerType = owner_type ? owner_type : 1

				this.formData.ownerPhone = owner_phone
				this.formData.ownerName = owner_name
				this.formData.registerCityInfo = {
					city: {
						name: registration_city_name,
						area_code: registration_city_code
					}
				}
				this.formData.cardTypeInfo = {
					value: owner_id_type,
					name: cardType[owner_id_type]
				}

				this.formData.ownerIdCode = owner_id_code
			} catch (e) {
				if (util.isInWebview()) {
					this.$router.push({ path: '/error', query: { message: '网络请求失败' } })
				}
			}
		}
	},
	watch: {
		formData: {
			handler(val) {
				if (val && val.checked) {
					this.$refs.ownerInfoForm.$refs.Form.validate()
						.then(() => {
							this.btnDisabled = false
						})
						.catch(() => {
							console.log('1')
							this.btnDisabled = true
						})
				} else {
					this.btnDisabled = true
				}
			},
			deep: true
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.order-creator-page {
	font-family: 'PingFang SC';
	.main-content {
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
		::v-deep {
			.nio-field {
				width: 100%;
				min-height: unset;
			}
			.nio-select {
				width: 100%;
			}
			.nio-sheet {
				&__header {
					padding: 12px 20px 12px 20px;
					height: 50px;
					@include subtitle_2(1.4, 700);
					color: $text_primary;
				}
				&__content {
					@include body_1(1.5, 400, false);
					padding: 20px;
				}
			}

			.van-cell {
				padding: 0 0;
				&::after {
					display: none;
				}
			}
		}
		&-title {
			@include headline_1(1.4, 400, false);
			color: $text_primary;
			&__tips {
				@include subtitle_4(1.5, 400, false);
				color: $text_secondary;
			}
			&__sub {
				@include headline_3(1.4, 400, false);
				color: $text_primary;
				margin-bottom: 20px;
			}
		}
		&-price-block {
			display: flex;
			justify-content: space-between;
			align-items: center;
			//border: 1px solid $text_primary;

			margin-bottom: 60px;
			&__label {
				@include body_1(1.5, 400, false);
				color: $text_primary;
			}
			&__value {
				color: $text_primary;
				@include body_1(1.5, 700, false);
			}
		}

		.section-car-card {
			margin-top: 30px;
			margin-bottom: 60px;

			::v-deep {
				.img-container {
					width: 100px !important;
					height: 100px !important;
				}

				.price-line {
					display: none;
				}

				.car-name {
					.nio-icon {
						display: none;
					}
				}
			}
		}
		.price-detail {
			margin-top: 60px;
			margin-bottom: 44px;
			&-block {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 26px;
				margin-top: 20px;
				margin-bottom: 15px;
				&-label {
					@include body_2(1.5, 400, false);
					color: $text_secondary;
				}
				&-value {
					@include body_2(1.8, 420);
					color: $text_primary;
				}
				&-additional {
					margin-top: 0;
					margin-bottom: 0;
				}
			}

			&-tips {
				@include body_3(1.5, 400, false);
				color: #cdced4;
			}
			&-money {
				@include body_3(1.5, 400, false);
				color: $text_tertiary;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 22.5px;
			}
		}
		.agreement {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			font-family: 'PingFang SC';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;
			margin-bottom: 20px;
			::v-deep {
				.nio-button {
					padding: 0 0;
					font-family: 'PingFang SC';
					font-style: normal;
					font-weight: 400;
					font-size: 14px;
					line-height: 20px;
					height: 40px;
				}
				.nio-check {
					padding-left: 0;
				}
			}
		}
		.submit-btn {
			padding-bottom: 20px;
			padding-bottom: var(env(safe-area-inset-bottom) + 20px);
		}
	}
}
</style>
